import React from 'react';

import OngoingSeriesRecordingWhite from 'assets/images/svgs/Recording/ico_ongoing_recording_all.svg';
import OngoingSeriesRecordingBlack from 'assets/images/svgs/Recording/ico_ongoing_recording_all_black.svg';

type Props = { highlighted: boolean; size: number };

function OngoingSeriesRecording({ highlighted, size }: Props) {
    return highlighted ? (
        <OngoingSeriesRecordingBlack width={size} height={size} />
    ) : (
        <OngoingSeriesRecordingWhite width={size} height={size} />
    );
}

export default OngoingSeriesRecording;
